export default "__VITE_ASSET__MCwNobWl__"